import { useMutation } from 'react-query';

import { api } from '../main-request/base';

// method: "post" | "get" | "put" | "patch" | "delete"
const useFileMutation = (method, url, options) =>
	useMutation(
		variables => {
			const response = api({ method, url, data: variables, responseType: 'blob' });
			return response;
		},
		{ ...options }
	);

export default useFileMutation;
